<template>
	<el-dialog
		title="选择快递网点"
		:visible.sync="visible"
		center
		@close="handlerCancel"
		width="300px"
	>
		<el-select v-model="current_id" placeholder="请选择快递网点" class="w-full">
			<el-option v-for="item in list" :label="item.company" :value="item.id" :key="item.id"></el-option>
		</el-select>
		<span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
	</el-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
	data() {
		return {
			current_id: null,
			visible: false,
			list: [],
			params: {},
			func: {},
			callback: {}
		}
	},
	mounted() {
		
	},
	methods: {
		...mapActions({
			getDdShopNetSiteList: "ucenter/getDdShopNetSiteList"
		}),
		open(params, shop_id, func, callback) {
			this.params = params;
			this.shop_id = shop_id;
			this.func = func;
			this.callback = callback
			this.visible = true;
			this.getDdShopNetSiteList({
				data: {
					shop_id: this.shop_id
				},
				success: (res) => {
					this.list = res.data.list;
				}
			})
		},
		handlerConfirm() {
			this.func({
				data: Object.assign(this.params, {share_bill_express: this.current_id}),
				success: (res) => {
					this.callback(res);
					this.visible = false;
				},
			})
		},
		handlerCancel() {
			this.visible = false;
		}
	}
}
</script>

<style scoped>

</style>